import { render } from "./KycConfirm.vue?vue&type=template&id=51f9e9aa&scoped=true"
import script from "./KycConfirm.vue?vue&type=script&lang=js"
export * from "./KycConfirm.vue?vue&type=script&lang=js"

import "./KycConfirm.vue?vue&type=style&index=0&id=51f9e9aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f9e9aa"]])

export default __exports__